module.exports = __webpack_public_path__ + "fonts/Luscious-Lifestyles-Script.6362939d.ttf";